import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b6530e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "table_boxs"
};
const _hoisted_3 = {
  class: "tab_boxs"
};
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import dicdialog from "./dicdialog.vue";
import { getDictListApi } from "@/service/modules/role";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    const data_list = ref([]);
    const keys = ref("");
    const get_list = async () => {
      loading.value = true;
      let reqdata = {
        page: 1,
        pageSize: 50
      };
      const res = await getDictListApi(reqdata);
      if (res.code == 0) {
        data_list.value = res.data.data;
        loading.value = false;
      }
    };
    get_list();
    const edits = row => {
      keys.value = row.key;
      DialogVisible.value = true;
    };
    const get_value = (value, index) => {
      let value_new = JSON.parse(value);
      if (index == 2) {
        return value_new[0].value;
      }
      if (index == 0 || index == 1 || index == 3) {
        return value_new[1].value;
      }
    };
    const get_text = (value, index) => {
      let value_new = JSON.parse(value);
      if (index == 2) {
        return "";
      }
      if (index == 0 || index == 1 || index == 3) {
        return value_new[0].value;
      }
    };
    const DialogVisible = ref(false);
    async function closeDialog() {
      DialogVisible.value = false;
    }
    async function restData() {
      closeDialog();
      get_list();
    }
    return (_ctx, _cache) => {
      const _component_top_title = _resolveComponent("top-title");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_top_title, {
        message: "配置设置"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data_list.value,
        height: "520",
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "名称",
          prop: "name"
        }), _createVNode(_component_el_table_column, {
          label: "图片"
        }, {
          default: _withCtx(scope => [get_value(scope.row.value, scope.$index) ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            style: {
              "width": "100px",
              "height": "100px"
            },
            src: get_value(scope.row.value, scope.$index),
            "zoom-rate": 1.2,
            "max-scale": 7,
            "min-scale": 0.2,
            "preview-src-list": [get_value(scope.row.value, scope.$index)],
            "preview-teleported": true,
            fit: "cover"
          }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "微信号/文案"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(get_text(scope.row.value, scope.$index)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => edits(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]])])]), DialogVisible.value ? (_openBlock(), _createBlock(dicdialog, {
        key: 0,
        "dialog-visible": DialogVisible.value,
        onCloseDialog: closeDialog,
        keys: keys.value,
        onRestData: restData
      }, null, 8, ["dialog-visible", "keys"])) : _createCommentVNode("", true)]);
    };
  }
});